// @ts-nocheck
import { isPast } from 'date-fns'
import { toZonedTime } from 'date-fns-tz'

export const useGutsStoryblok = stateId => {
  const route = useRoute()
  const story = useState(stateId)
  const editMode = ref(false)

  if (route.query?._storyblok) {
    editMode.value = true
  }

  const loadById = async (id, params) => {
    const { $lang, $api } = useNuxtApp()
    const language = route.query?._storyblok_lang ? route.query?._storyblok_lang : $lang === 'nl' ? 'default' : $lang

    if (editMode.value) {
      const storyblokApiInstance = useStoryblokApi()

      const { data, error } = await storyblokApiInstance.get(`cdn/stories/${id}`, { ...params, language })

      if (data) {
        story.value = data.story
      }
      return { data, error }
    }

    const { data } = await useAsyncData(`sb/stories/${id}`, () => {
      return $api(`sb/stories/${id}`, {
        params: {
          ...params,
          language
        }
      })
    })

    if (data.value) {
      if (
        !data.value.story.content.date_from ||
        (data.value.story.content.date_from && isPast(toZonedTime(data.value.story.content.date_from + '+0000', 'Europe/Amsterdam')))
      ) {
        story.value = data.value.story
        return story.value
      }

      if (!story.value) {
        throw new Error('not found')
      }
    }

    throw new Error('not found')
  }

  const loadByParams = async params => {
    const { $lang, $api } = useNuxtApp()
    const language = route.query?._storyblok_lang ? route.query?._storyblok_lang : $lang === 'nl' ? 'default' : $lang

    if (editMode.value) {
      const storyblokApiInstance = useStoryblokApi()
      const { data } = await storyblokApiInstance.get('cdn/stories/', {
        params: {
          language,
          ...params
        }
      })
      if (data) {
        story.value = data.story
      }
    } else {
      const { data } = await useAsyncData(`sb/stories/${JSON.stringify(params)}/${language}`, async () => {
        const data = await $api('sb/stories', {
          params: {
            language,
            ...params
          }
        })
        if (data) {
          return data
        }
      })

      if (data.value) {
        const filteredStories = data.value.stories.filter(story => {
          return isPast(toZonedTime(story.content.date_from + '+0000', 'Europe/Amsterdam'))
        })
        const sortedStories = filteredStories.sort((a, b) => {
          return Date.parse(toZonedTime(a.content.date_from + '+0000', 'Europe/Amsterdam')) < Date.parse(toZonedTime(b.content.date_from + '+0000', 'Europe/Amsterdam')) ? 1 : -1
        })
        story.value = sortedStories[0]
      }
    }
  }

  onMounted(async () => {
    await nextTick()
    if (story.value && story.value.id) {
      await useStoryblokBridge(
        story.value.id,
        evStory => { story.value = evStory },
        { preventClicks: true }
      )
    }
  })

  return { story, loadById, loadByParams }
}
